import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import ManufacturersForm from "../../../components/forms/setup/manufacturers/ManufacturersForm";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function ManufacturersViewModel(logout, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [manufacturers, setManufacturers] = useState({ data: [] });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id");

  const getManufacturers = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`manufacturers`, payload);
    setLoading(false);
    if (callResult.success) {
      setManufacturers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createManufacturer = async function (values) {
    const payload = { ...values, user_id: user_id };
    let callResult = await makePostApiCall("createManufacturer", payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Supplier added",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getManufacturers("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateManufacturer = async function (manufacturer, values, index) {
    let callResult = await makePutApiCall(
      `manufacturer/${manufacturer.id}`,
      values,
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Supplier updated",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getManufacturers("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddManufacturerSlideOver = () => {
    setSlideOver({
      childComponent: (
        <ManufacturersForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createManufacturer}
        />
      ),
      open: true,
    });
  };

  const viewManufacturerDetails = async function (manufacturer, index) {
    setSlideOver({
      childComponent: (
        <ManufacturersForm
          manufacturer={manufacturer}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateManufacturer}
        />
      ),
      open: true,
    });
  };

  const deleteManufacturer = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteManufacturer/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getManufacturers(null, 0);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteManufacturer = function (manufacturer, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteManufacturer(manufacturer.id, index)}
          message={`Are you sure you want to delete ${manufacturer.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteManufacturer,
    emptyModal,
    setEmptyModelOpen,
    getManufacturers,
    loading,
    manufacturers,
    openAddManufacturerSlideOver,
    setSlideOver,
    slideOver,
    viewManufacturerDetails,
  };
}
